import _debounce from 'lodash.debounce';

/**
 * Adjusts elements' bottom position on mobile devices
 *
 * THE PROBLEM:
 * You make an element stick to the bottom of the page. You see it on a mobile browser,
 * like Safari or Chrome, and the browser's UI covers the element.
 *
 * THE SOLUTION:
 * We calculate the inner height of the viewport (excludes browser's UI elements) and set
 * the "TOP" position of the "fixed" element.
 * Calculating the bottom space doesn't work because the viewport difference you would get
 * will include both the "top" and "bottom" parts of the browser, and only the "bottom"
 * bit is the issue.
 *
 * HOW THIS WORKS:
 * Add the class defined in "_watchSelector" to any element you want to target and the
 * adjustment will take place when the utility is initialised (i.e. page load) as well
 * as when the browser resizes. You can also manually trigger the refresh by calling
 * ElementBottomPositionMobileFix.refreshPositioning() method.
 *
 * If the device doesn't support touch events, the utility does nothing.
 */
const ElementBottomPositionMobileFix = {
  // Add this class to elements you want to watch
  _watchSelector: '.el-bottom-position-watched',

  init() {
    const self = this;

    // We only care about touch devices
    if ( ! this._isTouchDevice() ) {
      return;
    }

    // Event :: adjusts position on all watched elements when browser resizes
    window.onresize = _debounce(() => {
      self.refreshPositioning();
    }, 200);

    // Initial adjustment on page load
    this.refreshPositioning();
  },

  /**
   * You can manually call this method to trigger the re-positioning of elements
   */
  refreshPositioning() {
    // We only care about touch devices, remove watcher class
    if ( ! this._isTouchDevice() ) {
      return;
    }

    document.querySelectorAll(this._watchSelector).forEach(el => {
      el.style.position = 'fixed';
      el.style.top = parseInt(window.innerHeight - el.offsetHeight) + 'px';
    });
  },

  _isTouchDevice() {
    return (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0))
    ;
  }
};

export default ElementBottomPositionMobileFix;